import { React, useEffect, useState } from 'react'
import { CFormTextarea, CCard, CButton, CSpinner, CBadge, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CCardBody } from '@coreui/react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import InternalNotesCRUD from '../../services/general/internalNotesAPI.api'
import Carder from '../../components/shared/Carder'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import Graytextarea from '../../components/Graytextarea'
import { backgroundColor } from '@syncfusion/ej2-richtexteditor/src/rich-text-editor/models/items'
import { Calendar } from 'lucide-react'
import { useIndexedDB } from '../../context/IndexedContext'

const ProviderNotesBont = ({ patientID, loading, setLoading, saveTreatsShell, noteStructureRef, Notes, setNotes , noteCallType}) => {

 
  const [diagnosisData, setDiagnosisData] = useState([])
  const [textInput, setTextInput] = useState('')
  const [modalVisible, setModalVisible] = useState(false)
  const [activeTab, setActiveTab] = useState('old')
  const [currentDate, setCurrentDate] = useState('')
  const [noteEditId, setNotesEditId] = useState(null)
  const [loadings, setLoadings] = useState(false)
  const [editNote, setEditNote] = useState(null)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [editableInternalNote, setEditableInternalNote] = useState('')

  console.log('Notes-->', Notes)
  const editNotes = (note, tooChangeTab = true) => {
    setEditNote(note)
    setNotesEditId(note.Id)
    setModalVisible(true)
    setTextInput(note.InternalNotes)
    if (tooChangeTab) {
      setActiveTab('new')
    }
  }

  const handlePopulatingSameMetadataHisotry = () => {
    console.log('running handlePopulatingSameMetadataHisotry')
    const internalNoteId = noteStructureRef.current?.metadata?.internalNoteId
    if (internalNoteId) {
      setEditableInternalNote(internalNoteId)
      console.log(Notes, internalNoteId, 'Notes,editableInternalNote')
      const findSingleCurrentNoteAlwaysEditForThisNoteCreated = Notes.find((item) => item.Id === internalNoteId)
      console.log(findSingleCurrentNoteAlwaysEditForThisNoteCreated, 'findSingleCurrentNoteAlwaysEditForThisNoteCreated')
      if (findSingleCurrentNoteAlwaysEditForThisNoteCreated) {
        editNotes(findSingleCurrentNoteAlwaysEditForThisNoteCreated, false)
      }
    }
  }
  const addNote = async () => {
    if (!textInput.trim()) {
      toast.error('Please enter the note text', toastConfig)
      return
    }
    setLoadings(true)
    try {
      if (editNote !== null) {
        let allData = await InternalNotesCRUD('UPDATE', patientID.toString(), textInput, currentDate, noteEditId)
        // await getPatientInternalNotes()

        // setTextInput("")
        // setActiveTab("old")
        // setEditNote(null)
        // setNotesEditId(null)
        setLoadings(false)
        toast.success('Successfully Updated', toastConfig)
      } else {
        let allData = await InternalNotesCRUD('INSERT', patientID, textInput, currentDate)
        let history = JSON.parse(allData.d)
        const allNotess = await getPatientInternalNotes()
        if (allNotess.length > 0) {
          const latestNoteId = allNotess[0]?.Id

          noteStructureRef.current = {
            ...noteStructureRef.current,
            metadata: {
              ...noteStructureRef.current.metadata,
              internalNoteId: latestNoteId,
            },
          }
          setEditableInternalNote(latestNoteId)

          // Save the shell (passing false as an argument)
          await saveTreatsShell(false)

          setTextInput('')
          setActiveTab('old')
          setEditNote(null)
          setNotesEditId(null)
          setLoadings(false)
          toast.success('Successfully Added', toastConfig)
          handlePopulatingSameMetadataHisotry()
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  // const getPatientInternalNotes = async () => {
  //   let allData = await InternalNotesCRUD('GET', patientID)
  //   let history = JSON.parse(allData?.d)
  //   // let sortedNotes = history?.Data?.sort((a, b) => new Date(b.Date) - new Date(a.Date));
  //   let sortedNotes = history?.Data?.sort((a, b) => new Date(b.Id) - new Date(a.Id))
  //   setNotes(sortedNotes)
  //   return sortedNotes
  // }

  const getLoggedProviderId = () => {
    const provider = JSON.parse(localStorage.getItem('loggedUserProviderId'))
    return provider || null
  }

  const { getOfflineData, getProviderDetails , getOpenChartOfflineData} = useIndexedDB()
  const getPatientInternalNotes = async () => {
    const data =   noteCallType === 'OpenChart' ? await getOpenChartOfflineData()  : await getOfflineData()
    const loggedUserID = await getProviderDetails()
    let internalNote = data[loggedUserID?.ID] || []
    console.log('intCall', internalNote[patientID]?.interNote, data, loggedUserID)
    setNotes(internalNote[patientID]?.interNote || [])
    return internalNote[patientID?.interNote || []]
  }

  useEffect(() => {
    // getDiagnosisData();
    setCurrentDate(getFormattedDate())
  }, [patientID])

  const handleInputChange = (event) => {
    setTextInput(event.target.value)
  }

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    return `${mm}.${dd}.${yyyy}`
  }
  const handleDeleteInternalNotes = async () => {
    await InternalNotesCRUD('DELETE', '', '', '', deleteVisibleId?.toString())
    // await getPatientInternalNotes()
    setDeleteVisibleId(null)
    setEditNote(null)
    setTextInput('')
    setNotesEditId(null)
  }
  useEffect(() => {
    handlePopulatingSameMetadataHisotry()
  }, [Notes, activeTab])

  return (
    <>
      {/* delete modal */}
      <CModal visible={deleteVisibleId}>
        <CModalHeader>
          <CModalTitle>Warning</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
        </CModalBody>
        <hr className="p-0 m-0" />
        <CModalFooter className="p-3 m-0">
          <CButton
            onClick={() => {
              setDeleteVisibleId(null)
            }}
            className="text-white"
            color="secondary"
          >
            Close
          </CButton>
          <CButton onClick={handleDeleteInternalNotes} className="text-white" color="danger">
            Delete
          </CButton>
        </CModalFooter>
      </CModal>
      <div>
        {/* <CNav variant="pills" className="justify-content-center">
                    <CNavItem>
                        <CNavLink
                            active={activeTab === 'new'}
                            onClick={() => setActiveTab('new')}
                        >
                            New
                        </CNavLink>
                    </CNavItem>
                    <CNavItem>
                        <CNavLink
                            active={activeTab === 'old'}
                            onClick={() => setActiveTab('old')}
                        >
                            Existing
                        </CNavLink>
                    </CNavItem>
                </CNav> */}
        <CTabContent>
          <CTabPane visible={activeTab === 'new'} className="mt-4">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                <CSpinner color="primary" />
              </div>
            ) : (
              <>
                {/* <div className="mb-3">Date : {currentDate}</div>  */}

                <Graytextarea type="text" id="textInput" value={textInput} rows={3} onChange={handleInputChange} />

                <CButton style={{ marginTop: '10px' }} onClick={addNote} variant="outline" color="primary">
                  {loadings ? (
                    <>
                      <CSpinner component="span" size="sm" variant="grow" aria-hidden="true" />
                      Loading...
                    </>
                  ) : (
                    <>{noteEditId !== null ? 'Update' : 'Add'}</>
                  )}
                </CButton>
              </>
            )}
          </CTabPane>
          <CTabPane visible={activeTab === 'old'}>
            {Notes.length === 0 && (
              <div className="d-flex justify-content-center align-items-center text-muted" style={{ height: '50px' }}>
                <div
                  style={{
                    fontSize: '15px',
                    fontWeight: '600px',
                    color: 'gray',
                  }}
                >
                  No Back Office Note Found
                </div>
              </div>
            )}
            {Notes.length > 0 &&
              Notes.map((obj) => {
                return (
                  <>
                    {/* <Carder
                      // deleteFunc={ editableInternalNote === obj.Id ? () => { setDeleteVisibleId(obj.Id) } : null}
                      // editFunc={editableInternalNote === obj.Id ? () => { editNotes(obj) } : null}

                      style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' , background: '#191919' }}
                      className="mt-3 bg-gray"
                    >
                      <CCardBody>
                        <p style={{ whiteSpace: 'pre-line' }}>
                          <div className="mb-3">
                            <strong>Date:</strong> {new Date(obj.Date).toLocaleDateString('en-US')}
                          </div>
                          <div className="mb-3">
                            <strong>Note:</strong> {obj.InternalNotes}
                          </div>
                        </p>
                      </CCardBody>
                    </Carder> */}
                    <div
                      style={{
                        borderRadius: '1rem',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.6)',
                        backgroundColor: '#191919',
                        border: '1px solid #333',
                        padding: '1rem',
                        marginTop: '1rem',
                        color: '#f5f5f5',
                      }}
                    >
                      <div className="d-flex justify-content-start align-items-center gap-2">
                        <Calendar size={18} />
                        <strong style={{ color: '#aaa' }}> {new Date(obj.Date).toLocaleDateString('en-US')}</strong>
                      </div>
                      <div
                        className="mt-3"
                        style={{
                          whiteSpace: 'pre-wrap',
                        }}
                      >
                        {obj.InternalNotes}
                      </div>
                    </div>
                  </>
                )
              })}
          </CTabPane>
        </CTabContent>
      </div>
    </>
  )
}

export default ProviderNotesBont
